/**
 * Featured Series Block
 * Admin-curated featured series carousel
 */
import React, { useRef } from 'react';
import { Star } from 'lucide-react';
import { ScrollContainer, SectionHeader, SeriesCardHorizontal } from './shared';

const FeaturedSeriesBlock = ({ data = [], settings = {} }) => {
  const scrollRef = useRef(null);
  const series = data || [];
  
  const {
    title = 'Featured Series',
    layout = 'carousel',
    show_rank = true,
    max_items = 12,
    card_scale = 1.0,
    max_image_height = 280,
    columns = { desktop: 5, tablet: 3, mobile: 2 },
  } = settings;

  if (series.length === 0) return null;

  const displaySeries = series.slice(0, max_items);

  // Carousel layout
  if (layout === 'carousel') {
    return (
      <section data-testid="featured-series-block">
        <SectionHeader 
          title={title} 
          icon={Star} 
          iconColor="text-yellow-400" 
        />
        <ScrollContainer scrollRef={scrollRef}>
          {displaySeries.map((item, index) => (
            <SeriesCardHorizontal 
              key={item.series_id || item.id} 
              series={item.series || item} 
              rank={show_rank ? index + 1 : null}
              featured
              settings={{ card_scale, max_image_height, show_rank }}
            />
          ))}
        </ScrollContainer>
      </section>
    );
  }

  // Grid layout
  return (
    <section data-testid="featured-series-block">
      <SectionHeader 
        title={title} 
        icon={Star} 
        iconColor="text-yellow-400" 
      />
      <div 
        className="px-2 sm:px-6"
        style={{
          display: 'grid',
          gridTemplateColumns: `repeat(${columns.mobile}, 1fr)`,
          gap: '1rem',
        }}
      >
        <style>{`
          @media (min-width: 640px) {
            [data-testid="featured-series-block"] > div:last-child {
              grid-template-columns: repeat(${columns.tablet}, 1fr) !important;
            }
          }
          @media (min-width: 1024px) {
            [data-testid="featured-series-block"] > div:last-child {
              grid-template-columns: repeat(${columns.desktop}, 1fr) !important;
            }
          }
        `}</style>
        {displaySeries.map((item, index) => (
          <SeriesCardHorizontal 
            key={item.series_id || item.id} 
            series={item.series || item} 
            rank={show_rank ? index + 1 : null}
            featured
            settings={{ card_scale, max_image_height, show_rank }}
          />
        ))}
      </div>
    </section>
  );
};

export default FeaturedSeriesBlock;
